import React from 'react';
import { BackgroundProvider } from '../../components/BackgroundProvider';
import { FiltersPanel } from '../../components/FiltersPanel';
import { Header } from '../../components/Header';
import { Main } from '../../components/Main';
import { FiltersContainer } from '../FiltersContainer';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { GeoSwitcherWrapperContainer } from '../GeoSwitcherContainer';
import { MagazineContainer } from '../MagazineContainer';
import { ReviewsContainer } from '../ReviewsContainer';
import { VillagesContainer } from '../VillagesContainer';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { MainpageBrandFiltersBanner } from '../../components/AdfoxBanner';

export const HomeContainer = () => (
  <Main>
    <GeoSwitcherWrapperContainer />
    <BackgroundProvider>
      <Header>
        <FiltersPanel>
          <FiltersTabsContainer />
          <FiltersContainer />
        </FiltersPanel>
        <MainpageBrandFiltersBanner />
      </Header>
    </BackgroundProvider>
    <RecommendationsContainer />
    <VillagesContainer />
    <ReviewsContainer />
    <MagazineContainer />
  </Main>
);
